import { reactive, ref, computed } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as apiCommon from '@/api/common'

/**
 * ログアウト
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * ログアウト処理
     */
    logout: () => {

      // ログアウトAPIをコール
      const params = {}
      apiCommon.logout(params) 
        .then(response => {
          if (response) {
            const { data } = response

            // ローカルに保存されたログイントークン、リフレッシュトークンを削除
            store.dispatch('auth/setToken', { token: null, refreshToken: null})

            // ストアに保持していた各値をクリア
            store.dispatch('qa/clearAll')
            store.dispatch('bookList/clearAll')
            store.dispatch('documentDownloadsList/clearAll')
            store.dispatch('search/clearAll')
            store.dispatch('note/resetAllState')

            // ログアウト実施完了フラグをtrueに設定
            store.dispatch('common/setIsLoggedOut', true)

            // ログイン画面へ遷移
            if (store.state.common.device === 'sp') {
              router.push({ path: '/sp/login' })
            } else {
              router.push({ path: '/pc/login' })
            }
          }
        })

    }
  })

  return group1
}
